import { render, staticRenderFns } from "./VacationCreationModal.vue?vue&type=template&id=b2aacfde&scoped=true&"
import script from "./VacationCreationModal.vue?vue&type=script&lang=ts&"
export * from "./VacationCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aacfde",
  null
  
)

export default component.exports